import * as React from "react";
import { FieldProps } from "formik";
import { Form } from "antd";

const FormItem = Form.Item;

export const CheckboxField: React.FC<
  FieldProps<any> & {
    prefix: React.ReactNode;
    label?: string;
    className?: string;
    checkboxClassName?: string;
    disabled?: boolean;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  className = "text-white",
  checkboxClassName = "custom-checkbox",
  disabled = false,
  ...props
}) => {
    const errorMsg = touched[field.name] && errors[field.name];

    const handleChange = (e: any) => {
      if (disabled) return;
      setFieldValue(field.name, e.target.checked);
    };

    return (
      <FormItem
        help={
          errorMsg ? (
            <div className="text-red-500 text-sm ">
              {typeof errorMsg === "string"
                ? errorMsg
                : Array.isArray(errorMsg)
                ? errorMsg.join(", ")
                : null}
            </div>
          ) : null
        }
        validateStatus={errorMsg ? "error" : undefined}>
        <div className="w-full flex mt-2">
          <div className={className}>
            <div className="flex  items-center justify-start cursor-pointer">
              <input
                type="checkbox"
                {...field}
                checked={field.value || false}
                onChange={handleChange}
                disabled={disabled}
                className={checkboxClassName}
              />
              <div className="text-[#CECECF] text-[14px] ml-2 mt-[1.5px]">{label}</div>
            </div>
          </div>
        </div>
      </FormItem>
    );
  };